import React from 'react';
import { ToastContainer } from 'react-toastify';
import {
    BrowserRouter,
    Routes,
    Route
} from "react-router-dom";
import Login from './views/pages/Login';
import ReLogin from './views/pages/ReLogin';
import ForgotPassword from './views/pages/ForgotPassword';
import Dashboard from './views/pages/Dashboard';
import Users from './views/pages/Users/Users';
import UserSessionLogs from './views/pages/Users/UserSessionLogs';
import Error404 from './views/pages/Error404';

import ResetPassword from './views/pages/ResetPassword';
import Designations from './views/pages/Designations/Designations';

import LeavingReason from './views/pages/LeavingReason/LeavingReason';

import Clients from './views/pages/Clients/Clients';
import ClientEdit from './views/pages/Clients/ClientEdit';
import ClientMerge from './views/pages/Clients/ClientMerge';
import {ClientAddForm} from './views/pages/Clients/ClientAddForm';
import Contacts from './views/pages/Contacts/Contacts';
import ContactViewEdit from './views/pages/Contacts/ContactViewEdit';
//import { ContactAddForm } from './views/pages/Contacts/ContactAddForm';
import ContactAddForm from './views/pages/Contacts/ContactAddForm';
import Requirements from './views/pages/Requirements/Requirements';
import Profile from './views/pages/Profile';
import {default as RequirementStatus} from './views/pages/RequirementStatus/Status';
import {default as CandidateStatus} from './views/pages/CandidateStatus/Status';
import {default as InterviewStatus} from './views/pages/Masters/InterviewStatus/Status';
import Skills from './views/pages/Skills/Skills';
import { RequirementForm } from './views/pages/Requirements/RequirementForm';
import ModeOfWorks from './views/pages/ModeOfWorks/ModeOfWorks';
import Candidates from './views/pages/Candidates/Candidates';
import InterviewRounds from './views/pages/InterviewRounds/InterviewRounds';
import { CandidateForm } from './views/pages/Candidates/CandidateForm';
import Interviews from './views/pages/Interviews/Interviews';
import { InterviewFormNew } from './views/pages/Interviews/InterviewFormNew';
import UserRoles from './views/pages/UserRoles/UserRoles';
import Permission from './views/pages/Permission';
import Onboards from './views/pages/Onboards/Onboards';
import { OnboardForm } from './views/pages/Onboards/OnboardForm';
import Offboards from './views/pages/Offboards/Offboards';
import { OffboardForm } from './views/pages/Offboards/OffboardForm';
import Invoices from './views/pages/Invoices';
import EditInvoice from './views/pages/EditInvoice';
import EditCreditNote from './views/pages/EditCreditNote';
import Reports from './views/pages/Reports/Reports';
import MonthlyReports from './views/pages/Reports/MonthlyReports';
import DailyReports from './views/pages/Reports/DailyReports';
import FileGemini from './views/FileGemini';
import Resumes from './views/pages/Resumes/Resumes';
import Meetings from './views/pages/Meetings/Meetings';
import { MeetingForm } from './views/pages/Meetings/MeetingForm';
const basename = process.env.REACT_APP_BASENAME || '';
function App() {

    return (
        <>
            <BrowserRouter basename={basename}>
                <Routes>
                    <Route exact index element={<Login  />} />
                    <Route exact path="/login" element={<Login  />} />
                    <Route exact path="/re-login" element={<ReLogin  />} />
                    <Route exact path="/forgot-password" element={<ForgotPassword  />} />
                    <Route exact path={`/reset-password/:token`} element={<ResetPassword  />} />

                    <Route exact path="/profile" element={<Profile  />} />
                    <Route path="/profile/:user_unique_id" element={<Profile  />} />
                    <Route exact path="/dashboard" element={<Dashboard  />} />
                    
                    <Route exact path="/gemini" element={<FileGemini />} />
                    
                    <Route path='/' element={<Permission />}>
                        <Route exact path="/resumes" element={<Resumes />} />
                        <Route exact path="/clients" element={<Clients />} />
                        <Route exact path="/clients/merge" element={<ClientMerge />} />
                        <Route path="/clients/create" element={<ClientAddForm  />} />
                        <Route exact path="/clients/:unique_id/edit" element={<ClientEdit />} />
                        <Route exact path="/clients/:unique_id/view" element={<ClientEdit />} />

                        <Route exact path="/contacts/" element={<Contacts />} />
                        <Route path="/contacts/create" element={<ContactAddForm  />} />
                        <Route exact path="/contacts/:unique_id/view" element={<ContactViewEdit />} />
                        <Route exact path="/contacts/:unique_id/edit" element={<ContactViewEdit />} />

                        <Route exact path="/requirements" element={<Requirements />} />
                        <Route path="/requirements/create" element={<RequirementForm  />} />
                        <Route path="/requirements/:unique_id/edit" element={<RequirementForm  />} />
                        <Route path="/requirements/:unique_id/view" element={<RequirementForm  />} />

                        <Route exact path="/candidates" element={<Candidates />} />
                        <Route path="/candidates/create" element={<CandidateForm  />} />
                        <Route path="/candidates/:unique_id/edit" element={<CandidateForm  />} />
                        <Route path="/candidates/:unique_id/view" element={<CandidateForm  />} />

                        <Route exact path="/interviews" element={<Interviews />} />
                        <Route exact path="/interviews/create" element={<InterviewFormNew />} />
                        <Route exact path="/interviews/:unique_id/view" element={<InterviewFormNew />} />
                        <Route exact path="/interviews/:unique_id/edit" element={<InterviewFormNew />} />

                        <Route exact path="/onboards" element={<Onboards />} />
                        <Route path="/onboards/create" element={<OnboardForm  />} />
                        <Route path="/onboards/:unique_id/edit" element={<OnboardForm  />} />
                        <Route path="/onboards/:unique_id/view" element={<OnboardForm  />} />

                        <Route exact path="/offboards" element={<Offboards />} />
                        <Route path="/offboards/create" element={<OffboardForm  />} />
                        <Route path="/offboards/:unique_id/edit" element={<OffboardForm  />} />
                        <Route path="/offboards/:unique_id/view" element={<OffboardForm  />} />

                        <Route exact path="/meetings" element={<Meetings />} />
                        <Route path="/meetings/create" element={<MeetingForm />} />
                        <Route path="/meetings/:unique_id/edit" element={<MeetingForm />} />
                        <Route path="/meetings/:unique_id/view" element={<MeetingForm />} />

                        <Route exact path="/designations" element={<Designations />} />
                        <Route exact path="/leaving-reason" element={<LeavingReason />} />
                        <Route exact path="/requirement-status" element={<RequirementStatus />} />
                        <Route exact path="/skills" element={<Skills />} />
                        <Route exact path="/mode-of-works" element={<ModeOfWorks />} />
                        <Route exact path="/candidate-status" element={<CandidateStatus />} />
                        <Route exact path="/interview-rounds" element={<InterviewRounds />} />
                        <Route exact path="/interview-status" element={<InterviewStatus />} />

                        <Route exact path="/users" element={<Users  />} />
                        <Route exact path="/users/session-logs" element={<UserSessionLogs />} />
                        <Route exact path="/user-roles" element={<UserRoles />} />

                        <Route exact path="/invoices" element={<Invoices  />} />
                        <Route exact path="/invoices/:invoice_unique_id/edit" element={<EditInvoice  />} />
                        <Route exact path="/credit-notes/:credit_note_unique_id/edit" element={<EditCreditNote  />} />
                        <Route exact path="/reports/client-report" element={<Reports  />} />
                        <Route exact path="/reports/monthly-reports" element={<MonthlyReports  />} />
                        <Route exact path="/reports/daily-reports" element={<DailyReports  />} />
                    </Route>

                    <Route path="*" element={<Error404  />} />
                </Routes>
            </BrowserRouter>

            <ToastContainer
                position="bottom-right"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </>
    );
}

export default App;